export default __webpack_public_path__ + "static/media/maxdome_more_info_small.f010b7e2.mp4";